<div #dialogRoot cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{title}}</h2>

<mat-dialog-content>
    <div *ngIf="isShowHeader" style="display: flex; padding-bottom: 5px;">
        <span style="flex: 1;">Source Field</span>
        <span style="flex: 1;">Value</span>
    </div>
    <!-- Fields Section -->
    <ng-container *ngFor="let item of viewModel.textItems;let i = index">
        <div style="display: flex; align-items: center; gap: 5px;">
            <!-- Colored Source Field Name -->
            <span *ngIf="isShowHeader" style="flex: 1;" [style.color]="viewModel.sourceItems[i]?.color">
                {{ viewModel.sourceItems[i]?.text }}
            </span> 
            <!-- Input Field -->    
            <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="auto" style="flex: 2; max-width: 200px;">
                <input 
                  type="text" 
                  matInput 
                  [(ngModel)]="item.text" 
                  placeholder="Enter value" 
                  required 
                  style="height: 20px; padding: 3px 5px; color: white;"
                >
                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
              </mat-form-field>
        </div>
    </ng-container>
    <div *ngIf="!isShowHeader">
        <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
            *ngFor="let containItem of viewModel.sourceItems"
            [style.color]="containItem.color.color">{{containItem.text }} </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" class="save-btn" color="primary" mat-raised-button>SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close >CANCEL</button>
</mat-dialog-actions>
</div>